// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
document.addEventListener('DOMContentLoaded', function() {
    // Target your specific premium header navigation
    const navItems = document.querySelectorAll('.header-nav li');
    let currentParent = null;

    navItems.forEach(item => {
        const link = item.querySelector('a');
        
        // Check if the menu label starts with a hyphen
        if (link && link.textContent.trim().startsWith('-')) {
            // Clean up the text (remove the hyphen)
            link.textContent = link.textContent.trim().substring(1).trim();
            item.classList.add('nav-dropdown-item');

            // If there is a parent above it, create the dropdown structure
            if (currentParent) {
                let dropdown = currentParent.querySelector('.nav-dropdown');
                if (!dropdown) {
                    dropdown = document.createElement('ul');
                    dropdown.classList.add('nav-dropdown');
                    currentParent.classList.add('has-dropdown');
                    currentParent.appendChild(dropdown);
                    
                    // Add a subtle dropdown arrow to your parent link
                    currentParent.querySelector('a').innerHTML += ' <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 4px; opacity: 0.7;"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                }
                dropdown.appendChild(item);
            }
        } else {
            // If it doesn't start with a hyphen, it is a new parent
            currentParent = item;
        }
    });
});

